import React from 'react';
import '../template-file-css/document-file-template.css';



export const LaGeneral_LocusScoringSheet = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LaGeneral_LocusScoringSheet' className='file-pdf-document'>
            <div className='file-template'>

                <table>
                    <tr>
                        <td className='w-40'>&nbsp;</td>
                        <td className='w-320'><span className='eleHeader'>DIMENSIONS </span></td>
                        <td className='w-200'><span className='eleHeader'>CURRENT </span></td>
                        <td className='w-200'><span className='eleHeader'>CRITERIA </span></td>
                    </tr>
                    <tr>
                        <td className='w-40'><b>I.</b></td>
                        <td className='w-320'><span>RISK OF HARM</span></td>
                        <td className='w-200'>
                            <input type='text' id='txtCurrent_1' name='txtCurrent_1' className='add-only' /></td>
                        <td className='w-200'>
                            <input type='text' id='txtCriteria_1' name='txtCriteria_1' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-40'><b>II.</b></td>
                        <td className='w-320'><span>FUNCTIONAL STATUS</span></td>
                        <td className='w-200'>
                            <input type='text' id='txtCurrent_2' name='txtCurrent_2' className='add-only' /></td>
                        <td className='w-200'>
                            <input type='text' id='txtCriteria_2' name='txtCriteria_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-40'><b>III.</b></td>
                        <td className='w-320'><span>MEDICAL, ADDICTIVE, PSYCHIATRIC CO-MORBIDITY</span></td>
                        <td className='w-200'>
                            <input type='text' id='txtCurrent_3' name='txtCurrent_3' className='add-only' /></td>
                        <td className='w-200'>
                            <input type='text' id='txtCriteria_3' name='txtCriteria_3' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-40'><b>IV-A.</b></td>
                        <td className='w-320'><span>RECOVERY ENVIRONMENT (STRESS)</span></td>
                        <td className='w-200'>
                            <input type='text' id='txtCurrent_4' name='txtCurrent_4' className='add-only' /></td>
                        <td className='w-200'>
                            <input type='text' id='txtCriteria_4' name='txtCriteria_4' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-40'><b>IV-B.</b></td>
                        <td className='w-320'><span>RECOVERY ENVIRONMENT (SUPPORT)</span></td>
                        <td className='w-200'>
                            <input type='text' id='txtCurrent_5' name='txtCurrent_5' className='add-only' /></td>
                        <td className='w-200'>
                            <input type='text' id='txtCriteria_5' name='txtCriteria_5' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-40'><b>V.</b></td>
                        <td className='w-320'><span>RESILIENCY AND TREATMENT</span></td>
                        <td className='w-200'>
                            <input type='text' id='txtCurrent_6' name='txtCurrent_6' className='add-only' /></td>
                        <td className='w-200'>
                            <input type='text' id='txtCriteria_6' name='txtCriteria_6' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-40'><b>VI.</b></td>
                        <td className='w-320'><span>ENGAGEMENT</span></td>
                        <td className='w-200'>
                            <input type='text' id='txtCurrent_7' name='txtCurrent_7' className='add-only' /></td>
                        <td className='w-200'>
                            <input type='text' id='txtCriteria_7' name='txtCriteria_7' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>COMPOSITE SCORE:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtCompositeScore' name='txtCompositeScore' className='add-only' />
                        </td>
                    </tr>

                </table>

                <p>
                    <span className='eleHeader'>LEVEL OF CARE RECOMMENDED:</span>
                    <textarea id='txtRecommended' name='txtRecommended' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-250'>LMHP PRINTED NAME </td>
                        <td className='small w-250'>LMHP SIGNATURE </td>
                        <td className='small w-250'>DATE </td>
                    </tr>
                </table>


            </div>
        </form >

    )
}











